import * as styles from "./IntroOurCentres.module.scss";

import React from "react";
import CurvedBorder from "../../../components/borders/CurvedBorder";
import InlineLocationFilters from "../../../containers/filters/InlineLocationFilters/InlineLocationFilters";
import { Colours } from "../../../utils/colours";

export interface SectionSpotlightDogsProps {
	title: string;
	body: string;
}

export const IntroOurCentres: React.FC<SectionSpotlightDogsProps> = ({
	title,
	body,
}) => {
	return (
		<>
			<div className={styles.introcolumnouterdesktop}>
				<div className={styles.introcolumninner}>
					<div className={styles.twocolumncontent}>
						<div className={styles.leftcolumn}>
							<div className={styles.text}>
								<h1>{title}</h1>
								{body && (
									<div
										// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
										dangerouslySetInnerHTML={{
											__html: body,
										}}
									/>
								)}
							</div>
						</div>
						<div className={styles.rightcolumn}>
							<InlineLocationFilters />
						</div>
					</div>
				</div>
			</div>
			<div className={styles.introcolumnoutermobile}>
				<div className={styles.introcolumninner}>
					<div className={styles.tworowcontent}>
						<div className={styles.toprow}>
							<div className={styles.text}>
								<h1>{title}</h1>
								{body && (
									<div
										// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
										dangerouslySetInnerHTML={{
											__html: body,
										}}
									/>
								)}
							</div>
							<div className={styles.rowscurvedborder}>
								<CurvedBorder fill={Colours.SANDY_FUR} rotation={0} />
							</div>
						</div>
						<div className={styles.bottomrow}>
							<InlineLocationFilters />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default IntroOurCentres;
